import { Instance, InstanceMap } from "../../triggers/semantic-dive/semantic-dive";

// Gets a list of all children of instanceId
export const getChildInstances = (
  instanceId: string,
  instanceMap: InstanceMap
) => {
  return Object.values(instanceMap)
    .filter(instance => instance.parentId === instanceId);
}

// Gets a list of all sub-instances of the instance
export const getInstanceSubtree = (
  instanceId: string,
  instanceMap: InstanceMap
): Instance[] => {
  const childInstances = getChildInstances(instanceId, instanceMap);
  console.log(childInstances);
  return childInstances
    .concat(childInstances
      .flatMap(childInstance => getInstanceSubtree(childInstance.topicNode.id, instanceMap)));
}